import { IBoundingBox } from './IBoundingBox.js';
import { IMatrix4 } from './IMatrix4.js';
import { IVector3 } from './IVector3.js';
export class IBoundingSphere {
    constructor(position, radius) {
        return {
            position: position,
            radius: radius
        };
    }
    static to_bounding_box(bounding_sphere) {
        const r = new IVector3(bounding_sphere.radius);
        return new IBoundingBox(IVector3.subtract(bounding_sphere.position, r), IVector3.add(bounding_sphere.position, r));
    }
    /**
     * Calculates if the given bounds are valid, i.e. has a volume
     * @param bounds The bounds to check
     * @returns true if the bounds are valid
     */
    static is_valid(bounds) {
        return bounds.radius > 0.0;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static Invalid() {
        return new IBoundingSphere(new IVector3(), -1);
    }
    /**
     * Type guard to check if the provided object is applicable to the `IBoundingSphere` interface.
     * @returns Type assertion if the object is applicable to the IBoundingSphere.
     */
    static is(value) {
        const bounding_sphere = value;
        return 'position' in bounding_sphere && 'radius' in bounding_sphere && IVector3.is(bounding_sphere.position) && typeof bounding_sphere.radius === 'number';
    }
    static transformed_bounding_sphere(sphere, transform) {
        let radius_scale = 0;
        for (let i = 0; i < 3; i++) {
            radius_scale = Math.max(radius_scale, IVector3.magnitude_squared(transform[i]));
        }
        radius_scale = Math.sqrt(radius_scale);
        return new IBoundingSphere(IMatrix4.transform_vector3(transform, sphere.position), sphere.radius * radius_scale);
    }
}
//# sourceMappingURL=IBoundingSphere.js.map